import BaseBoilerplatePromoModal from 'src/components/Promotions/BaseBoilerplatePromoModal.svelte';
import { PROMOTIONS } from 'src/constants';
import type { ModalConfig } from 'src/types/Modals';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

export const ShellyBirthdayTeaserModalConfig = (): ModalConfig => ({
	id: 'shellyBirthdayTeaser',
	component: BaseBoilerplatePromoModal,
	props: {
		showModal: true,
		urlPath:
			'pages/shelly-birthday?utm_source=shellyapp&utm_medium=referral&utm_campaign=shelly_7th_birthday',
		imageUrl: './images/shelly-birthday-7-teaser.png',
		modalTitle: get(format)('modal_title_shelly_birthday'),
		heading: get(format)('alert_heading_birthday_invitation'),
		secondHeading: get(format)('text_primary_heading_teaser_2'),
		dateSentence: get(format)('sentence_join_for_present', {
			values: {
				datePrimarySpan: `<span class="text-primary text-600">${get(format)('span_before_date')}</span>`,
			},
		}),
		buttonText: get(format)('button_join_now'),
	},
	rules: [
		{
			check: () => {
				const now = new Date().getTime();
				return (
					now >= PROMOTIONS.SHELLY_BIRTHDAY_TEASER.START_DATE &&
					now < PROMOTIONS.SHELLY_BIRTHDAY_TEASER.END_DATE
				);
			},
			expected: true,
		},
	],
});
